import { Tooltip } from "antd";

import { useStores } from "stores";
import { EditQuoteExpTimeModal } from "./EditQuoteExpTimeModal";
import { ReactComponent as EditIcon } from "images/editIcon.svg";

interface Props {
  defaultQuoteExpTime: string;
}

export const EditQuoteExpTimeButton = ({ defaultQuoteExpTime }: Props) => {
  const { actionModals } = useStores();

  const openModal = () => {
    actionModals.open(() => <EditQuoteExpTimeModal currentValue={defaultQuoteExpTime} />, {
      width: "600px",
      isOverlayClose: false,
      noValidation: true,
      title: "Изменение параметров",
    });
  };

  return (
    <Tooltip trigger="hover" title={"Редактировать срок действия"}>
      <EditIcon className="cursor-pointer" onClick={() => openModal()} />
    </Tooltip>
  );
};
